export enum WorkerStoryTypeEnum {
  VIDEO = 'video',
  PHOTOS = 'photos',
  TEXT = 'text',
}
